/**
 * Linear interpolation between two values (lerping)
 *
 * @param {number} start Minimum value
 * @param {number} end   Maximum value
 * @param {number} alpha Lerp factor
 * @return {number} Lerped value
 */
export function lerp(start, end, alpha) {
  return start * (1 - alpha) + end * alpha
}
